export type IsUrlOnAllowlist = (url: string, allowlist?: RegExp) => boolean;

const allowlistExpression = new RegExp(
    '^(/myaccount|/my-enquiries|/house-prices|/discover|/property/|/(to-rent|for-sale|new-homes)/(details/(contact/)?[0-9]+|(commercial|property))|/favourites/(properties|tracked-properties)|(/find-agents/[a-z]+/))'
);

export const isUrlOnAllowlist: IsUrlOnAllowlist = (
    url,
    allowlistMatcher = allowlistExpression
) => {
    const decodedUrl = decodeURIComponent(url);

    return Boolean(decodedUrl.match(allowlistMatcher)?.[0]);
};
